module.exports = __webpack_public_path__ + "static/media/favicon.cfb373eb.svg";